import { combineReducers } from "redux";
import { neapExams } from "./types";
import produce from "immer";

export const initialState = {
  isLoading: false,
  data: null,
  error: false,
};

const examsListReducer = (state = initialState, action = {}) =>
  produce(state, (draft) => {
    switch (action.type) {
      case neapExams.EXAMS_LIST_REQUEST:
        draft.isLoading = true;
        draft.error = false;
        break;
      case neapExams.EXAMS_LIST_REQUEST_SUCCESS:
        draft.isLoading = false;
        draft.data = action.payload.data;
        break;
      case neapExams.EXAMS_LIST_REQUEST_ERROR:
        draft.isLoading = false;
        draft.error = action.error;
        break;
      default:
        draft = state;
        break;
    }
  });

const neapExamsReducer = combineReducers({
  examsListReducer,
});

export default neapExamsReducer;
